// src/components/AuthActivity/RiskBadge/RiskBadge.js

import React from "react";
import "./RiskBadge.css";

const RiskBadge = ({ level }) => (
  <span className={`risk-badge risk-badge--${level}`}>
    {level} risk
  </span>
);

export default RiskBadge;